import React from 'react';
import SearchCombobox from '../search_combobox/SearchCombobox';
import type { SearchComboboxProps } from '../search_combobox/SearchCombobox';
import { user_matches, user_option_label } from './user_match';
import type { ComboUser } from './user_match';

export type { ComboUser } from './user_match';

type Props = Omit<SearchComboboxProps<ComboUser>, 'items' | 'get_key' | 'get_label' | 'matches'> & {
  users: ComboUser[];
};

const user_key = (u: ComboUser): string => u.uuid;

function UserCombobox({
  id,
  users,
  value,
  on_change,
  label = 'User',
  placeholder = 'Type a name or email',
  disabled,
  width,
  max_rows
}: Props) {
  return (
    <SearchCombobox<ComboUser>
      id={id}
      items={users}
      get_key={user_key}
      get_label={user_option_label}
      matches={user_matches}
      value={value}
      on_change={on_change}
      label={label}
      placeholder={placeholder}
      disabled={disabled}
      width={width}
      max_rows={max_rows}
    />
  );
}

export default UserCombobox;
